export default __webpack_public_path__ + "static/media/angular-tip.11f2668e.png";